import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import PrivacyPolicy from '../components/privacy-policy'
import Footer from '../components/footer'
import './privacy-policy-page.css'

const PrivacyPolicyPage = (props) => {
  return (
    <div className="privacy-policy-page-container">
      <Helmet>
        <title>Privacy Policy - Stefan Lacher | Software Solutions</title>
        <meta
          name="description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:title"
          content="Privacy Policy - Stefan Lacher | Software Solutions"
        />
        <meta
          property="og:description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/50551946-307e-48ab-899a-950ab7a25dad/6b02e41a-da5a-475f-a28c-27c456397767?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Header
        textAbout={
          <Fragment>
            <span className="privacy-policy-page-text100">About</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="privacy-policy-page-text101">Contact</span>
          </Fragment>
        }
        textProjects={
          <Fragment>
            <span className="privacy-policy-page-text102">Projects</span>
          </Fragment>
        }
        textServices={
          <Fragment>
            <span className="privacy-policy-page-text103">Services</span>
          </Fragment>
        }
        textAboutMobile={
          <Fragment>
            <span className="privacy-policy-page-text104">About</span>
          </Fragment>
        }
        textContactMobile={
          <Fragment>
            <span className="privacy-policy-page-text105">Contact</span>
          </Fragment>
        }
        textProjectsMobile={
          <Fragment>
            <span className="privacy-policy-page-text106">Projects</span>
          </Fragment>
        }
        textServicesMobile={
          <Fragment>
            <span className="privacy-policy-page-text107">Services</span>
          </Fragment>
        }
      ></Header>
      <PrivacyPolicy></PrivacyPolicy>
      <Footer
        textMade={
          <Fragment>
            <span className="privacy-policy-page-text229">Made with</span>
          </Fragment>
        }
        textName={
          <Fragment>
            <span className="privacy-policy-page-text230">Stefan Lacher</span>
          </Fragment>
        }
        textYear={
          <Fragment>
            <span className="privacy-policy-page-text231">© 2025</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="privacy-policy-page-text232">Contact</span>
          </Fragment>
        }
        textImpressum={
          <Fragment>
            <span className="privacy-policy-page-text233">Impressum</span>
          </Fragment>
        }
        textPrivacyPolicy={
          <Fragment>
            <span className="privacy-policy-page-text234">Privacy Policy</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default PrivacyPolicyPage
